module.exports = __webpack_public_path__ + "static/img/5.a704496.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/5.png
// module id = YtqB
// module chunks = 0